'use client'

import React, { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { memberService } from '@/modules/member'
import { dialog } from '@/modules/ui/dialog'
import { moveToLoginPage } from '@/utils/moveToLoginPage'
import { usePurchaseInfo } from '@/hooks/purchase/usePurchaseInfo'
import { PurchaseItem } from '@/types/purchase.type'
import { memberStore } from '@/store/member.store'
import { homeActionLog } from '@/modules/action-log/home'

interface PurchaseButtonProps extends PurchaseItem {}

export const PurchaseButtonSection = () => {
  const { purchaseItemList, syncStorePurchaseItemList } = usePurchaseInfo()

  useEffect(() => {
    syncStorePurchaseItemList()
  }, [])

  return (
    <div className="fixed bottom-0 left-1/2 transform -translate-x-1/2 w-full pc:w-[512px] z-3">
      <div className="flex gap-[16px] mt-auto items-center mb-[20px] px-[20px]">
        {purchaseItemList.map((item, index) => (
          <PurchaseButton key={item.id} {...item} />
        ))}
      </div>
    </div>
  )
}

const PurchaseButton = ({
  id,
  productCode,
  name,
  price,
  productType,
  cardCount,
  discountType,
  discountValue,
  finalPrice,
  free,
}: PurchaseButtonProps) => {
  const router = useRouter()
  const finalPriceText = finalPrice.toLocaleString()
  const discountPriceText = price.toLocaleString()
  const { isUnder14 } = memberStore()

  const handleClickPurchasePage = async () => {
    homeActionLog.clickPurchase({ purchaseCount: cardCount, free })

    if (!memberService.isLogin()) {
      const confirmLogin = await dialog.openMessage({
        title: '로그인이 필요한 서비스입니다.',
        message: '로그인 하시겠습니까?',
        cancelVisible: true,
        confirmMessage: '네',
        cancelMessage: '아니오',
      })

      if (confirmLogin) {
        moveToLoginPage()

        return
      }

      return
    }

    if (isUnder14) {
      await dialog.openMessage({
        title: '14세 미만 고객은 구매가 불가능한 컨텐츠입니다.',
        confirmMessage: '확인',
      })

      return
    }

    router.push(`/purchase?productCode=${productCode}`)
  }

  const isProductCodeTypePack2 = productCode === 'loopy_pack_10'

  return (
    <div className="relative flex-1 h-[72px]">
      <div
        className={`p-[2px] rounded-[10px] overflow-hidden ${isProductCodeTypePack2 ? 'bg-gradient-to-r from-[#C788EB] via-[#E9C2F7] via-[#86DCF9] to-[#FFBEED]' : ''}`}
        onClick={handleClickPurchasePage}
      >
        {isProductCodeTypePack2 && (
          <img src="/img/tag/loopy/discount.svg" className="absolute top-[-4px] right-[-4px] z-10" />
        )}
        <div className="flex flex-col gap-[2px] bg-pink-1 rounded-[8px] p-[15px] w-full">
          <p className="text-white text-center  text-[20px] font-bold leading-[24px]">{cardCount}장</p>
          <div className="flex items-center justify-center gap-[4px]">
            {isProductCodeTypePack2 && (
              <p className="text-gray-2 opacity-60 text-[10px] font-normal leading-[16px] line-through">
                {discountPriceText}원
              </p>
            )}

            <p className="text-gray-1 text-[12px] font-medium leading-[16px]">{finalPriceText}원</p>
          </div>
        </div>
      </div>
    </div>
  )
}
